<template>
  <div>
    <the-header />
    <section id="page-content">
      <div class="container-fluid">
        <header class="header-page">
          <h1>{{ siteName }}</h1>
          <h2 class="text-muted">Review</h2>
          <div class="step-progress-bar">
            <div class="step-progress" style="width:75%;"></div>
          </div>
        </header>
        <PassList allowPassRemoval="false" :agencyName="agencyName" />

        <div v-if="passCount > 1">
          <hr />
          <h2>Receipt Delivery</h2>
          <p>
            Once purchased, your passes will be sent to the email addresses
            listed above. Please enter the email address where you would like
            the receipt sent.
          </p>
          <div class="form-group">
            <input
              :value="deliveryEmail"
              @change="updateOrderSummary"
              class="form-control"
            />
          </div>
        </div>
        <div class="form-actions">
          <button
            v-show="!loading"
            id="back"
            type="button"
            @click="back"
            class="btn btn-secondary btn-lg"
          >
            <font-awesome-icon
              icon="chevron-left"
              class="fa fa-fw"
            />Back</button
          >&nbsp;
          <button
            v-show="!loading"
            id="purchase"
            type="button"
            @click="purchasePasses"
            class="btn btn-primary btn-lg"
          >
            Purchase <font-awesome-icon icon="chevron-right" class="fa fa-fw" />
          </button>
          <span v-if="loading"
            ><font-awesome-icon icon="spinner" class="fa fa-fw fa-pulse fa-2x"
          /></span>
        </div>
      </div>
    </section>
    <the-footer />
  </div>
</template>

<script>
import TheHeader from "@/components/Shared/TheHeader.vue";
import TheFooter from "@/components/Shared/TheFooter.vue";
import PassList from "@/components/Passes/PassList.vue";
import { library } from "@fortawesome/fontawesome-svg-core";
import {
  faChevronRight,
  faChevronLeft,
  faSpinner
} from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/vue-fontawesome";
library.add(faChevronRight);
library.add(faChevronLeft);
library.add(faSpinner);

export default {
  name: "Checkout",
  components: {
    TheHeader,
    TheFooter,
    PassList,
    FontAwesomeIcon
  },
  data() {
    return {
      loading: false
    };
  },
  computed: {
    siteName() {
      return this.$store.getters["cart/siteName"];
    },
    passCount() {
      let passes = this.$store.getters["cart/passes"];
      return passes.length;
    },
    deliveryEmail() {
      let summary = this.$store.getters["cart/orderDetails"];
      return summary["deliveryEmail"];
    },
    agencyName() {
      return this.$store.getters["cart/agencyName"];
    }
  },
  methods: {
    back() {
      this.$router.go(-1);
    },
    purchasePasses() {
      this.loading = true;
      this.$store
        .dispatch("cart/checkout")
        .then(() => {
          if (this.$store.getters["cart/status"] === "pendingPayment") {
            //this.$router.push({ name: "payment" });
            window.location = this.$store.getters["cart/paymentUrl"];
          } else {
            this.loading = false;
          }
        })
        .catch(error => {
          this.loading = false;
          throw error;
        });
    },
    updateOrderSummary(event) {
      this.$store.commit("cart/updateOrder", {
        name: "deliveryEmail",
        value: event.target.value
      });
    }
  },
  beforeMount() {
    let summary = this.$store.getters["cart/orderDetails"];
    if (!summary["deliveryEmail"]) {
      let passes = this.$store.getters["cart/passes"];
      this.$store.commit("cart/updateOrder", {
        name: "deliveryEmail",
        value: passes[0].visitoremail
      });
    }
  }
};
</script>
